export default __webpack_public_path__ + "3f45c52f6c7aa84b0cc3e599bece9c5b.jpg";